<template>
  <base-container style="text-align:center">
    <img alt="Vue logo" src="/img/logo.png" />
    <h1>加班研发中，请耐心等待！！！</h1>
  </base-container>
</template>
<script>
export default {
};
</script>
<style scoped>

</style>
